import React from "react";
import styles from "./radioBox.module.scss";
import Icon from "features/shared/components/icons/Icon";
import { RadioBoxDesignProps } from "./RadioBoxDesignProps";

interface Props extends RadioBoxDesignProps {
  name: string;
  label: string;
  value: string | undefined;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checked: boolean;
}

const RadioBox = ({
  name,
  label,
  value,
  onChange,
  checked,
  icon,
  text,
  disabled,
  heightAsFormControl,
  className,
  classNameTitle,
  classNameIcon,
  classNameText,
}: Props) => {
  // private props
  const radioBoxId = `${name}-${value}`;

  // sub-render
  const renderIcon = () => {
    if (icon) {
      return (
        <span
          className={`${styles.radioBoxIcon}${
            classNameIcon ? " " + classNameIcon : ""
          }`}
        >
          <Icon icon={icon.icon} size={icon.size ?? "lg"} />
        </span>
      );
    }
  };

  const renderText = () => {
    if (text) {
      return (
        <div
          className={`${styles.radioBoxText}${
            classNameText ? " " + classNameText : ""
          }`}
        >
          {text}
        </div>
      );
    }
  };

  // render
  return (
    <div className="postion-relative">
      <input
        type="radio"
        name={name}
        id={radioBoxId}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={styles.radioBoxInput}
      />
      <label
        className={`${styles.radioBox}${
          heightAsFormControl ? " " + styles.formControlHeight : ""
        }${className ? " " + className : ""}`}
        htmlFor={radioBoxId}
      >
        <div className="d-flex align-items-center">
          {renderIcon()}
          <div>
            <h6
              className={`${styles.radioBoxTitle}${
                classNameTitle ? " " + classNameTitle : ""
              }`}
            >
              {label}
            </h6>
            {renderText()}
          </div>
        </div>
      </label>
    </div>
  );
};

export default RadioBox;
